import { render, staticRenderFns } from "./shippingTemplate.vue?vue&type=template&id=2c4f2131&scoped=true"
import script from "./shippingTemplate.vue?vue&type=script&lang=js"
export * from "./shippingTemplate.vue?vue&type=script&lang=js"
import style0 from "./shippingTemplate.vue?vue&type=style&index=0&id=2c4f2131&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f2131",
  null
  
)

export default component.exports